var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100Camera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9299 11.0932L18.0375 9.27385V14.7262L14.9299 12.9068V15.0322C14.9299 15.3883 14.785 15.7299 14.5269 15.9817C14.2688 16.2335 13.9187 16.375 13.5537 16.375H7.33867C6.97368 16.375 6.62364 16.2335 6.36556 15.9817C6.10747 15.7299 5.96248 15.3883 5.96248 15.0322V8.96782C5.96248 8.61168 6.10747 8.27013 6.36556 8.0183C6.62364 7.76648 6.97368 7.625 7.33867 7.625H13.5537C13.9187 7.625 14.2688 7.76648 14.5269 8.0183C14.785 8.27013 14.9299 8.61168 14.9299 8.96782V11.0932ZM7.1611 8.79455V15.2054H13.7313V8.79455H7.1611Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Camera);
export default __webpack_public_path__ + "static/media/100-camera.0dd0538e8d92b54e7867fe8fe19632d6.svg";
export { ForwardRef as ReactComponent };